import React from 'react';
import { Tooltip, Button, Radio } from 'antd';
import {
  PieChartOutlined, BarChartOutlined, LineChartOutlined, AreaChartOutlined,
  TableOutlined, DotChartOutlined, RedoOutlined,
  SwapOutlined, PercentageOutlined, FileAddOutlined, NumberOutlined, DashboardOutlined, EditOutlined, InfoCircleOutlined, FileImageOutlined, FileExcelOutlined,
} from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import useFormatMessage from 'hooks/useFormatMessage';
import globalMessages from 'translations/messages';
import StackedBarChartIcon from '../../Icons/StackedBarChartIcon';
import messages from '../messages';

import './chart-toolbox.less';
import { getGradingScale } from '../utils';

const ChartToolbox = ({
  left,
  type,
  switchChartType,
  displayMode,
  switchDisplayMode,
  switchAxis,
  sortAxisAndData,
  chartTypes = [],
  showScore,
  displayModeScoreLabel = 'displayModeScore',
  displayModeValueLabel = 'displayModeValue',
  displayModePercentageLabel = 'displayModePercentage',
  showPercentage,
  compare,
  saveAsImage,
  onDownload,
  addToReport,
  hasData,
  onEdit,
  onChange,
  displayGradingScale,
  question,
}) => {
  const $t = useFormatMessage();

  return (
    <div className="chart__toolbox">
      <div className="chart__toolbox-left">
        {switchChartType && (
        <Radio.Group buttonStyle="solid" value={type} onChange={e => switchChartType(e.target.value)}>
          {chartTypes.includes('bar') && (
          <Tooltip key="bar" placement="topLeft" title={<FormattedMessage {...messages.bar} />}>
            <Radio.Button value="bar">
              <BarChartOutlined />
            </Radio.Button>
          </Tooltip>
          )}
          {chartTypes.includes('pie') && (
          <Tooltip key="pie" placement="topLeft" title={<FormattedMessage {...messages.pie} />}>
            <Radio.Button value="pie">
              <PieChartOutlined />
            </Radio.Button>
          </Tooltip>
          )}
          {chartTypes.includes('line') && (
          <Tooltip key="line" placement="topLeft" title={<FormattedMessage {...messages.line} />}>
            <Radio.Button value="line">
              <LineChartOutlined />
            </Radio.Button>
          </Tooltip>
          )}
          {chartTypes.includes('area') && (
          <Tooltip key="area" placement="topLeft" title={<FormattedMessage {...messages.area} />}>
            <Radio.Button value="area">
              <AreaChartOutlined />
            </Radio.Button>
          </Tooltip>
          )}
          {chartTypes.includes('stacked') && (
          <Tooltip key="stacked" placement="topLeft" title={<FormattedMessage {...messages.stacked} />}>
            <Radio.Button value="stacked">
              <StackedBarChartIcon />
            </Radio.Button>
          </Tooltip>
          )}
          {chartTypes.includes('scatter') && (
          <Tooltip key="scatter" placement="topLeft" title={<FormattedMessage {...messages.scatter} />}>
            <Radio.Button value="scatter">
              <DotChartOutlined />
            </Radio.Button>
          </Tooltip>
          )}
          <Tooltip key="table" placement="topLeft" title={<FormattedMessage {...messages.table} />}>
            <Radio.Button value="table">
              <TableOutlined />
            </Radio.Button>
          </Tooltip>
        </Radio.Group>
        )}
        {hasData && (
        <>
          {(switchAxis || sortAxisAndData) && (
          <Button.Group>
            {switchAxis && (
            <Tooltip title={<FormattedMessage {...messages.switchAxis} />}>
              <Button icon={<RedoOutlined />} onClick={switchAxis} />
            </Tooltip>
            )}
            {sortAxisAndData && (
            <Tooltip title={<FormattedMessage {...messages.sort} />}>
              <Button icon={<SwapOutlined />} onClick={sortAxisAndData} />
            </Tooltip>
            )}
          </Button.Group>
          )}

          {(showScore || showPercentage) && (
          <Radio.Group buttonStyle="solid" value={displayMode} onChange={e => switchDisplayMode(e.target.value)}>
            {showScore && (
            <Tooltip key="score" placement="topLeft" title={<FormattedMessage {...messages[displayModeScoreLabel]} />}>
              <Radio.Button value="score">
                <DashboardOutlined />
              </Radio.Button>
            </Tooltip>
            )}
            {showPercentage && (
            <Tooltip key="percentage" placement="topLeft" title={<FormattedMessage {...messages[displayModePercentageLabel]} />}>
              <Radio.Button value="percentage">
                <PercentageOutlined />
              </Radio.Button>
            </Tooltip>
            )}
            <Tooltip key="value" placement="topLeft" title={<FormattedMessage {...messages[displayModeValueLabel]} />}>
              <Radio.Button value="value">
                <NumberOutlined />
              </Radio.Button>
            </Tooltip>
          </Radio.Group>
          )}

          {getGradingScale(question, { type, displayMode }, $t) && (
          <Tooltip key="value" placement="topLeft" title={<FormattedMessage {...messages.displayGradingScale} />}>
            <Button type={displayGradingScale ? 'primary' : 'default'} icon={<InfoCircleOutlined />} onClick={() => onChange({ displayGradingScale: !displayGradingScale })} />
          </Tooltip>
          )}
        </>
        )}
        {left}
      </div>

      <div className="chart__toolbox-right">
        <Button.Group>
          {hasData && compare && (
          <Tooltip title={<FormattedMessage {...messages.compare} />}>
            <Button icon={<DotChartOutlined />} onClick={compare} />
          </Tooltip>
          )}
          {hasData && saveAsImage && (
          <Tooltip title={<FormattedMessage {...messages.saveAsImage} />}>
            <Button icon={<FileImageOutlined />} onClick={saveAsImage} />
          </Tooltip>
          )}
          {hasData && onDownload && (
          <Tooltip title={<FormattedMessage {...messages.downloadAsExcel} />}>
            <Button icon={<FileExcelOutlined />} onClick={onDownload} />
          </Tooltip>
          )}
          {addToReport && (
          <Tooltip placement="topRight" title={<FormattedMessage {...messages.saveReport} />}>
            <Button icon={<FileAddOutlined />} onClick={addToReport} />
          </Tooltip>
          )}
        </Button.Group>
        {onEdit && <Button type="primary" icon={<EditOutlined />} onClick={onEdit}><FormattedMessage {...globalMessages.edit} /></Button>}
      </div>

    </div>
  );
};

export default ChartToolbox;
